import log from "@/lib/log";

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

export async function buildScoreCardBlob(score, label = "LEGACY READINESS") {
  try {
    await Promise.all([
      document.fonts.load('600 110px "Cormorant Garamond"'),
      document.fonts.load('700 30px "Plus Jakarta Sans"'),
    ]);
  } catch (e) {
    log.debug("Brand fonts not ready; using system fonts for score card", e);
  }
  const img = await loadImage("/og-image-vertical.png");
  const canvas = document.createElement("canvas");
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, 1080, 1920);

  const cx = 540, cy = 1350, r = 128;
  ctx.save();
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fillStyle = "rgba(7, 17, 30, 0.55)";
  ctx.fill();
  const ring = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r);
  ring.addColorStop(0, "#E9C86A");
  ring.addColorStop(0.5, "#C59B27");
  ring.addColorStop(1, "#997314");
  ctx.lineWidth = 5;
  ctx.strokeStyle = ring;
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(cx, cy, r - 16, 0, Math.PI * 2);
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = "rgba(214, 187, 124, 0.55)";
  ctx.stroke();

  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillStyle = "#F6F1E7";
  ctx.font = '600 110px "Cormorant Garamond", Georgia, serif';
  ctx.fillText(`${score}%`, cx, cy - 14);
  ctx.font = '700 28px "Plus Jakarta Sans", system-ui, sans-serif';
  ctx.fillStyle = "#D6BB7C";
  if ("letterSpacing" in ctx) ctx.letterSpacing = "8px";
  ctx.fillText(label, cx, cy + 70);
  ctx.restore();

  return new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
}
